var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#BFDFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.90576 7C8.11571 5.76576 9.80179 5 11.6667 5C13.5317 5 15.2177 5.76576 16.4277 7M14.6482 9C13.9157 8.18167 12.8513 7.66667 11.6667 7.66667C10.482 7.66667 9.41765 8.18167 8.68522 9M11.6667 14.3333C12.6737 14.3333 13.6405 14.5051 14.5396 14.8209C14.5695 14.8313 14.5845 14.8366 14.608 14.847C14.8217 14.9412 14.9859 15.1727 15.0039 15.4056C15.0059 15.4313 15.0059 15.4541 15.0059 15.4996C15.0059 15.6547 15.0059 15.7323 15.0123 15.7977C15.0748 16.4305 15.5754 16.9311 16.2082 16.9935C16.2735 17 16.3511 17 16.5063 17H16.6696C16.9767 17 17.1301 17 17.2579 16.9748C17.7886 16.8702 18.2035 16.4553 18.3081 15.9245C18.3333 15.7968 18.3333 15.6433 18.3333 15.3363V15.2041C18.3333 14.8873 18.3333 14.7289 18.2995 14.5473C18.2239 14.1413 17.9289 13.6389 17.6111 13.3749C17.469 13.2569 17.3726 13.2032 17.1799 13.0957C15.548 12.1854 13.6679 11.6667 11.6667 11.6667C9.66541 11.6667 7.78531 12.1854 6.15347 13.0957C5.96073 13.2032 5.86436 13.2569 5.72227 13.3749C5.4045 13.6389 5.10947 14.1413 5.03383 14.5473C5 14.7289 5 14.8873 5 15.2041V15.3363C5 15.6433 5 15.7968 5.02517 15.9245C5.12979 16.4553 5.54473 16.8702 6.07547 16.9748C6.20317 17 6.35669 17 6.66373 17H6.82705C6.98221 17 7.0598 17 7.12515 16.9935C7.75793 16.9311 8.25853 16.4305 8.32101 15.7977C8.32747 15.7323 8.32747 15.6547 8.32747 15.4996C8.32747 15.4541 8.32747 15.4313 8.32945 15.4056C8.34748 15.1727 8.5116 14.9412 8.72532 14.847C8.7489 14.8366 8.76385 14.8313 8.79374 14.8209C9.69281 14.5051 10.6597 14.3333 11.6667 14.3333Z",
    stroke: "#2D97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.dd84896ab7c5b266976bca4e579d2d49.svg";
export { ForwardRef as ReactComponent };